import initialAllState from 'store/hoReducers/fileSystem/initialState';

const initialState = {
  ...initialAllState,
  list: {
    isLoading: false,
    error: '',
    paginationOptions: {
      page: 1,
      size: 100,
    },
    data: {
      items: [],
      count: 0,
    },
  },
  open: {
    isLoading: false,
    error: '',
    data: {},
  },
};

export default initialState;
